import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7c6baaf6")

_pushScopeId("data-v-7c6baaf6")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 患者一覧 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_PatientSearchForm = _resolveComponent("PatientSearchForm")
  const _component_PatientList = _resolveComponent("PatientList")
  const _component_vue_two_column_content = _resolveComponent("vue-two-column-content")
  const _component_vue_content_remain = _resolveComponent("vue-content-remain")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_vue_content_remain, null, {
        default: _withId(() => [
          _createVNode(_component_vue_two_column_content, null, {
            left: _withId(() => [
              _createVNode(_component_PatientSearchForm)
            ]),
            right: _withId(() => [
              _createVNode(_component_PatientList)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})